<template>
  <div>
    <FiltersForm
      :has-filters="hasFilters"
      :is-skeleton-loading="isSkeletonLoading"
      @filter="onFilter"
      @clear="onClearFilters"
      v-model="selectedCountries"
    >
      <v-text-field
        clearable
        v-model="search"
        type="search"
        :label="$t('search')"
        prepend-inner-icon="search"
      />

      <base-date-picker
        :date="issueDate"
        placeholder="Issue date"
        :config="dateConfig"
        :on-change="onChangeIssueDate"
      />

      <base-date-picker
        :date="invoicePeriod"
        placeholder="Invoice period"
        :config="dateConfig"
        :on-change="onChangeInvoicePeriod"
      />
    </FiltersForm>
  </div>
</template>

<script>
  import FiltersForm from './FiltersBase';
  import { isNonEmptyArr } from '@/utils';

  export default {
    components: {
      FiltersForm,
    },
    props: {
      isSkeletonLoading: {
        type: Boolean,
        default: false
      }
    },
    emits: ['clearFilters', 'filter'],
    data() {
      return {
        issueDate: '',
        invoicePeriod: '',
        selectedCountries: [],
        dateConfig: {
          mode: 'range',
        },
        search: '',
      };
    },
    computed: {
      hasFilters() {
        const {
          search,
          issueDate,
          invoicePeriod,
          selectedCountries
        } = this;
        return search !== '' ||
          issueDate !== '' ||
          invoicePeriod !== '' ||
          isNonEmptyArr(selectedCountries);
      },
    },
    methods: {
      onChangeIssueDate(dates) {
        this.issueDate = dates;
      },
      onChangeInvoicePeriod(dates) {
        this.invoicePeriod = dates;
      },
      onFilter() {
        const { search, issueDate, invoicePeriod, selectedCountries } = this;

        this.$emit('filter', {
          search,
          issueDate,
          invoicePeriod,
          countries: selectedCountries
        });
      },
      onClearFilters() {
        this.search = '';
        this.issueDate = '';
        this.invoicePeriod = '';
        this.selectedCountries = [];

        const { search, issueDate, invoicePeriod, selectedCountries } = this;
        this.$emit('clearFilters', {
          search,
          issueDate,
          invoicePeriod,
          countries: selectedCountries
        });
      },
    },
  };
</script>

<style lang="scss">

</style>
